import axios from 'axios';
const BASE_URL = process.env.REACT_APP_IMPRESSION_BASE_URL;

export const getRecentViewOfferIDByInsight = async (insightId) => {
    try {
        // Get response
        let response = await axios.get(
            `${BASE_URL}/get/offers/` + insightId + '/top-10-most-viewed',
        );
        return response.data;
    } catch (err) {
        console.log("error make new impression record:", err);
        throw err;
    }
};


